import React from "react";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useQuery } from "react-query";
import Loading from "../../../../components/Loading";
import { mutateErrors } from "../../../../utils";
import Error from "../../../../components/Error";
import PageHeader from "../../../../components/PageHeader";
import Grid from "@material-ui/core/Grid";
import UserListItem from "../../components/admin/UserListItem";
import useUserQueries from "../../hooks/useUserQueries";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default function ListPage() {
  const classes = useStyles();
  const { fetchAll } = useUserQueries();
  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("users", fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader title={"Users"} subtitle={"Here are listed users"} />
      </Container>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {data &&
            data.data.map((user: any, index) => (
              <UserListItem
                user={user}
                refetch={refetch}
                key={`UserListItem_${index}`}
              />
            ))}
        </Grid>
      </Container>
    </>
  );
}
